import * as actionTypes from "actions/actionTypes/snackbarActionTypes";
import { showEvent } from "actions/actionCreators/snackbarActions";
import initialState from "./initialState";
import { snackbarType } from "constants/snackbarType";
import { errorEvents, warningEvents, informationEvents } from "constants/errorEventTypes";
import { SIGNAL_R_EVENT_RECEIVED, OIDC_USER_EXPIRING } from "../actions/actionTypes";

export default function snackbarReducer(state = initialState.snackbar, action) {
  if (errorEvents.some(e => action.type.indexOf(e) > -1)) {
    const properAction = showEvent(action.event);
    return {
      ...state,
      msg: properAction.payload,
      type: snackbarType.error,
      correlationId: properAction.correlationId,
      shouldAddNotification: false
    };
  }

  if (warningEvents.some(e => action.type.indexOf(e) > -1)) {
    const properAction = showEvent(action.event);
    return {
      ...state,
      msg: properAction.payload,
      type: snackbarType.warning,
      correlationId: properAction.correlationId,
      shouldAddNotification: false
    };
  }

  if (informationEvents.some(e => action.type.indexOf(e) > -1)) {
    const properAction = showEvent(action.event);
    return {
      ...state,
      msg: properAction.payload,
      type: snackbarType.info,
      correlationId: properAction.correlationId,
      shouldAddNotification: false
    };
  }

  if (action.event?.eventBody?.shouldAddNotification && action.type !== SIGNAL_R_EVENT_RECEIVED) {
    const properAction = showEvent({ ...action.event, ok: true });
    return {
      ...state,
      ...properAction.payload,
      type: snackbarType.info,
      correlationId: action.event.correlationId,
      shouldAddNotification: true
    };
  }

  switch (action.type) {
    case actionTypes.SHOW_SNACKBAR_INFO: {
      return { ...state, ...action.payload, type: snackbarType.info, shouldAddNotification: false };
    }

    case actionTypes.SHOW_SNACKBAR_ERROR: {
      return {
        ...state,
        msg: action.payload,
        type: snackbarType.error,
        correlationId: action.correlationId,
        shouldAddNotification: false
      };
    }

    case actionTypes.SHOW_SNACKBAR_WARNING: {
      return {
        ...state,
        msg: action.payload,
        type: snackbarType.warning,
        correlationId: action.correlationId,
        shouldAddNotification: false
      };
    }

    case OIDC_USER_EXPIRING:
    case actionTypes.CLEAR_SNACKBAR: {
      return { ...initialState.snackbar };
    }

    default:
      return state;
  }
}
